import { Search, Globe, ChevronDown, User } from 'lucide-react';
import { SITE, GAMES } from '../mock';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';

const Header = () => {
  const [game, setGame] = useState('Free Fire');
  const [currency, setCurrency] = useState('USD');
  const [lang, setLang] = useState('English');
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0a1428cc] border-b border-white/5">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 h-16 flex items-center gap-3 lg:gap-5">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <img src={SITE.logo} alt={SITE.name} className="h-11 w-11 object-contain drop-shadow" />
          <span className="hidden md:inline text-[15px] font-bold tracking-tight bg-gradient-to-r from-amber-200 to-yellow-400 bg-clip-text text-transparent">
            {SITE.name}
          </span>
        </Link>

        {/* Game selector */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="hidden sm:flex items-center gap-2 h-10 px-3 rounded-md bg-white/5 hover:bg-white/10 border border-white/10 text-sm min-w-[150px] justify-between">
              <span className="truncate">{game}</span>
              <ChevronDown className="h-4 w-4 opacity-70" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="bg-[#0f1a38] border-white/10 text-white">
            {GAMES.map((g) => (
              <DropdownMenuItem key={g.id} onClick={() => setGame(g.name)} className="cursor-pointer focus:bg-white/10">
                {g.name}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>

        {/* Search */}
        <div className="flex-1 max-w-2xl relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && navigate('/market/free-fire/accounts')}
            placeholder="Search offers..."
            className="w-full h-10 pl-9 pr-4 rounded-md bg-white/5 border border-white/10 text-sm placeholder:text-slate-400 focus:outline-none focus:border-amber-400/50"
          />
        </div>

        <div className="hidden lg:flex items-center gap-2">
          <Button variant="ghost" className="h-10 px-4 text-slate-200 hover:bg-white/10 hover:text-white">
            Login
          </Button>
          <Button className="h-10 px-4 bg-amber-400 hover:bg-amber-300 text-slate-900 font-semibold">
            Register
          </Button>
        </div>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="hidden md:flex items-center gap-1 h-10 px-2 rounded-md hover:bg-white/10 text-sm">
              {currency}
              <ChevronDown className="h-4 w-4 opacity-70" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="bg-[#0f1a38] border-white/10 text-white">
            {['USD', 'EUR', 'IDR', 'INR', 'BRL'].map((c) => (
              <DropdownMenuItem key={c} onClick={() => setCurrency(c)} className="cursor-pointer focus:bg-white/10">
                {c}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="hidden md:flex items-center gap-1 h-10 px-2 rounded-md hover:bg-white/10 text-sm">
              <Globe className="h-4 w-4" />
              <span>{lang}</span>
              <ChevronDown className="h-4 w-4 opacity-70" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="bg-[#0f1a38] border-white/10 text-white">
            {['English', 'Bahasa', 'Español', 'Português'].map((l) => (
              <DropdownMenuItem key={l} onClick={() => setLang(l)} className="cursor-pointer focus:bg-white/10">
                {l}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>

        <button className="lg:hidden h-10 w-10 grid place-items-center rounded-md hover:bg-white/10">
          <User className="h-5 w-5" />
        </button>
      </div>
    </header>
  );
};

export default Header;
